import { post, get } from '../axios'

// 校验混合collection
export function mixCol_checkMixCol_post(map, option) {
  return post(
    `${process.env.VUE_APP_MIXCOL}/mixCol/checkMixCol`,
    map,
    option
  ).then(response => response)
}

// 查询混合collection详情
export function mixCol_getMixColDetail_mixId_get(map, option) {
  return get(
    `${process.env.VUE_APP_MIXCOL}/mixCol/getMixColDetail/${map.mixId}`,
    map,
    option
  ).then(response => response)
}

// 分页查询混合collection信息
export function mixCol_page_post(map, option) {
  return post(`${process.env.VUE_APP_MIXCOL}/mixCol/page`, map, option).then(
    response => response
  )
}

// 解除
export function mixCol_remove_mixId_get(map, option) {
  return get(
    `${process.env.VUE_APP_MIXCOL}/mixCol/remove/${map.mixId}`,
    map,
    option
  ).then(response => response)
}

// 保存混合collection
export function mixCol_saveMixCol_post(map, option) {
  return post(
    `${process.env.VUE_APP_MIXCOL}/mixCol/saveMixCol`,
    map,
    option
  ).then(response => response)
}
